export default "<div [class]=\"type\"> \r\n    <ng-content></ng-content>\r\n</div>\r\n  "